import React from 'react'

const UserList = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/userList',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M12.875 5.643h6.531A.6.6 0 0 0 20 5.036a.6.6 0 0 0-.594-.607h-6.531a.6.6 0 0 0-.594.607.6.6 0 0 0 .594.607M19.406 8.071h-6.531a.6.6 0 0 0-.594.608.6.6 0 0 0 .594.607h6.531A.6.6 0 0 0 20 8.679a.6.6 0 0 0-.594-.608M19.406 11.714h-3.562a.6.6 0 0 0-.594.607.6.6 0 0 0 .594.608h3.562A.6.6 0 0 0 20 12.32a.6.6 0 0 0-.594-.607M19.406 15.357h-3.562a.6.6 0 0 0-.594.607.6.6 0 0 0 .594.607h3.562a.6.6 0 0 0 .594-.607.6.6 0 0 0-.594-.607M11.688 17.786h-9.5v-3.183c0-.815.512-1.517 1.276-1.748 2.317-.7 4.542-.718 6.942.007a1.808 1.808 0 0 1 1.281 1.75v3.174zm-.946-6.088c-2.619-.79-5.079-.775-7.615-.007C1.854 12.076 1 13.246 1 14.603v3.79a.6.6 0 0 0 .594.607H12.28a.6.6 0 0 0 .594-.607v-3.78c0-1.358-.857-2.53-2.133-2.915z'
        fill={primaryColor} />
      <path
        d='M6.938 3.214c1.31 0 2.375 1.09 2.375 2.429 0 1.366-1.097 3.036-2.376 3.036-1.278 0-2.375-1.67-2.375-3.036 0-1.34 1.066-2.429 2.375-2.429m0 6.679c2.007 0 3.563-2.285 3.563-4.25C10.5 3.633 8.902 2 6.937 2 4.973 2 3.376 3.634 3.376 5.643c0 1.965 1.556 4.25 3.563 4.25'
        fill={secondaryColor} />
    </g>
  </svg>
)

export default UserList
